var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:{ 'has-error': _vm.hasError }},[_c('div',{staticClass:"captcha-box g-recaptcha",attrs:{"id":"captcha-box"}}),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"help-block"},[_vm._v(_vm._s(_vm.overrideErrorText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }